export class PaymentRequest {
  bundleId: number;
  bundleCredit: number;
  bundleAmount: number;
  bundleCustom: boolean;
  customerName: string;
  customerMobile: string;
  customerToken: string;
  paymentOption: string;
  confirmCode: string;
  orderCode: string;
  service: string;
  serviceId: number;

  constructor() {
    this.bundleId = 0;
    this.bundleCredit = 0;
    this.bundleAmount = 0;
    this.bundleCustom = false;
    this.customerName = '';
    this.customerMobile = '';
    this.customerToken = '';
    this.paymentOption = '';
    this.confirmCode = '';
    this.orderCode = '';
    this.service = '';
    this.serviceId = null;
  }
}

export class PaymentResponse {
  orderCode: string;
  refCode: string;
  status: string;
  service: string;

  constructor() {
    this.orderCode = '';
    this.refCode = '';
    this.status = '';
    this.service = '';
  }
}

export class PaymentOption {
  name: string;
  shortName: string;
  maximumAmount: number;
  active: boolean;
  reason: string;
  logourl: string;

  constructor() {
    this.name = '';
    this.shortName = '';
    this.maximumAmount = 0;
    this.active = false;
    this.reason = '';
    this.logourl = '';
  }
}

export class PaymentOptionResponse {
  options: PaymentOption[];
  gateway: string;
  fees: number;
  charge_fees: boolean;

  constructor() {
    this.options = [];
    this.gateway = '';
    this.fees = 0;
    this.charge_fees = false;
  }
}

